// components/Payroll/PayrollDashboard.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Button, Box } from '@mui/material';
import { Payment, List, Receipt } from '@mui/icons-material';

const PayrollDashboard: React.FC = () => {
  return (
    <div className="p-6">
      <Typography variant="h4" gutterBottom>
        Payroll Management
      </Typography>
      
      <Grid container spacing={3} className="mt-4">
        {/* Run Payroll Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent className="text-center">
              <Payment className="text-4xl text-primary-green mb-4" />
              <Typography variant="h6" gutterBottom>
                Run Payroll
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mb-4">
                Process payroll for the current period
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/dashboard/payroll/runs"
              >
                Run Payroll
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Payroll History Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent className="text-center">
              <List className="text-4xl text-green-600 mb-4" />
              <Typography variant="h6" gutterBottom>
                Payroll History
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mb-4">
                View past payroll runs and reports
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/dashboard/payroll/runs"
              >
                View History
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Pay Stubs Card */}
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent className="text-center">
              <Receipt className="text-4xl text-purple-600 mb-4" />
              <Typography variant="h6" gutterBottom>
                Pay Stubs
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mb-4">
                Access employee pay stubs
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/dashboard/payroll/paystubs"
              >
                View Pay Stubs
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Quick Stats */}
      <Box className="mt-8">
        <Typography variant="h5" gutterBottom>
          Payroll Overview
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Next Pay Date
                </Typography>
                <Typography variant="h4">
                  {/* This would come from your payroll context */}
                  Apr 15
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Employees Paid
                </Typography>
                <Typography variant="h4">
                  {/* This would come from your payroll context */}
                  24
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Total Payroll
                </Typography>
                <Typography variant="h4">
                  {/* This would come from your payroll context */}
                  $85,240
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default PayrollDashboard;